<template>
    <div class="avatar-preview-background" v-if="avatar !== null">
        <svg :viewBox="aspect === 'landscape' ? '0 0 1920 1080' : '0 0 1080 1920'" :height="aspect === 'landscape' ? '1080' : '1920'" :width="aspect === 'landscape' ? '1920' : '1080'"></svg>
        <video class="avatar-preview-background-object" v-if="backgroundType === 'video'" muted autoplay loop webkit-playsinline="true" playsinline :src="backgroundUrl"></video>
        <img class="avatar-preview-background-object" v-else-if="backgroundUrl" :src="backgroundUrl" />

        <slot></slot>

        <div :class="{'avatar-circle': circle, 'avatar-preview-background-drag': avatar, 'avatar-preview-background-drag-zoom-in': position.scale > 1 || aspect !== 'landscape'}" ref="dragger">
            <div v-if="avatar" class="avatar-preview-background-drag-renderer" :style="{'left': position.x*100 + '%', 'top': (-position.y)*100 + '%'}">
                <img :src="avatar.preview_url" :srcset="avatar.image + ' 1x'" :style="{ 'height': position.scale*100 + '%' }" @load="enableDrag" />
            </div>
        </div>

        <!-- div v-if="project && project.project_tier && !project.project_tier.id" class="avatar-preview-watermark"></div-->
        <div v-if="avatar" class="avatar-preview-actions">
            <icon @click="circleSet" class="icon-button" :class="{'icon-button-selected': circle !== ''}" icon="user" height="28" />
            <icon @click="left" class="icon-button" icon="arrow-left" height="28" />
            <icon @click="right" class="icon-button" icon="arrow-right" height="28" />
            <icon @click="scaleIn" class="icon-button" icon="plus" height="28" />
            <span class="avatar-preview-actions-percentage">{{Math.round(position.scale*100)}}%</span>
            <icon @click="scaleOut" class="icon-button" icon="minus" height="28" />
            <icon @click="recenter" v-if="position.x !== 0 || position.y !== 0 || position.scale !== 1" class="icon-button active" icon="restore" height="28" />
        </div>
    </div>
</template>
<script>
import { Drag } from "@/utils/drag";

export default {
    dragger: null,

    components: { },
    props: {
        aspect: {
            required: false,
            default: "landscape"
        },
        avatar: {
            required: true
        },
        backgroundType: {
            required: true
        },
        backgroundUrl: {
            required: true
        },
        position: {
            required: true
        },
        circle: {
            required: false
        }
    },
    data() {
        return {
        };
    },
    computed: {
    },
    methods: {
        circleSet() {
            this.$emit("circle-change", this.circle === "" ? "#ffffff" : "");
        },
        disableDrag() {
            if (this.$options.dragger) {
                this.$options.dragger.destroy();
            }
            this.$options.dragger = null;
        },
        enableDrag() {
            this.disableDrag();

            const move = {
                dragX: 0,
                dragY: 0,
                x: 0,
                y: 0
            };

            if (!this.$refs.dragger) {
                return;
            }

            this.$options.dragger = new Drag(this.$refs.dragger, (x, y, starting) => {
                if (starting) {
                    move.dragX = x;
                    move.dragY = y;
                    move.x = this.position.x;
                    move.y = -this.position.y;
                }

                const newPosition = { x: 0, y: 0 };
                newPosition.x = x - move.dragX + move.x;
                newPosition.y = y - move.dragY + move.y;

                const scale = this.position.scale === 0 ? 1 : this.position.scale;

                // snap to bottom when close
                if (newPosition.y > ((scale - 1) / -2) - 0.05 && newPosition.y < ((scale - 1) / -2) + 0.1) {
                    newPosition.y = ((scale - 1) / -2);
                }

                // restrict left and right
                if (newPosition.x > 0.5) {
                    newPosition.x = 0.5;
                } else if (newPosition.x < -0.5) {
                    newPosition.x = -0.5;
                }

                const position = this.position;
                position.x = newPosition.x;
                position.y = -newPosition.y;
            });
        },
        recenter() {
            const position = this.position;
            position.x = 0;
            position.y = 0;
            position.scale = 1;
        },
        right() {
            const position = this.position;
            position.x = 0.25;
        },
        left() {
            const position = this.position;
            position.x = -0.25;
        },
        scaleIn() {
            let scale = this.position.scale;
            if (scale === 0) {
                scale = 1;
            }
            if (scale < 2.5) {
                scale += 0.05;
            }
            const position = this.position;
            position.scale = scale;
        },
        scaleOut() {
            let scale = this.position.scale;
            if (scale === 0) {
                scale = 1;
            }
            if (scale > 0.05) {
                scale -= 0.05;
            }
            const position = this.position;
            position.scale = scale;
        }
    },
    mounted() {
        this.enableDrag();
    },
    destroyed() {
        this.disableDrag();
    },
    watch: {
        avatar(val) {
            if (val && !this.$options.dragger) {
                this.enableDrag();
            } else {
                this.disableDrag();
            }
        }
    }
};
</script>
<style lang="scss">
.avatar-preview-background {
    display: block;
    overflow: hidden;
    position: relative;
    background-color: black;
    max-width: 1080px;
    margin: 0 auto;

    svg {
        width: 100%;
        height: auto;
        display: block;
    }

    video {
    }

    .avatar-preview-background-object {
        object-fit: cover;
        width: 100%;
        height: 100%;
        max-width: 1080px;
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        display: block;
    }

    .avatar-preview-background-drag {
        object-fit: contain;
        width: 100%;
        height: 100%;
        max-width: 1080px;
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        display: block;
        cursor: move;

        &-renderer {
            position: absolute;
            width: 100%;
            height: 100%;
            pointer-events: none;

            /* debug drag
            background-color: rgba(0, 0, 0, 0.2);
            */

            img {
                object-fit: contain;
                margin: auto;
                position: absolute;
                left: 0;
                right: 0;
                bottom: 0;
                top: 0;
                pointer-events: none;
            }
        }
    }

    .avatar-preview-background-drag-zoom-in {
        .avatar-preview-background-drag-renderer img {
            object-fit: cover;
            aspect-ratio: 1/1;
            object-position: center;
        }
    }

    .avatar-circle {
        .avatar-preview-background-drag-renderer img {
            height: 100%;
            background: white;
            border-radius: 100%;
            aspect-ratio: 1/1;
        }
    }

    .avatar-preview-actions {
        position: absolute;
        vertical-align: middle;
        left: 15px;
        bottom: 15px;

        .icon-button {
            margin-right: 5px;
            background-color: rgba(255, 255, 255, 0.3);
            border-radius: 3px;
            padding: 5px;

            &-selected {
                background-color: rgba(255, 255, 255, 0.5);
            }
        }
        svg {
            stroke: black;
        }

        &-percentage {
            width: 45px;
            display: inline-block;
            text-align: center;
            vertical-align: middle;
            margin-right: 15px;
            color: black;
        }
    }
}
</style>
